<template>
  <div id="app">
    <ModalBackground
      @deactivateModal="deactivateModal"
      :outerWrapperStyles="modalStyles" 
      :innerWrapperStyles="modalContentStyles" 
    />
    <div
      v-if="modalActive" 
      class="undermaintenence">
      <h1 class="newfont">We're Currently Closing This Site</h1> 
      <h3 class="newfont">Features and Forms will not work</h3>
      <h3 class="newfont">Thanks for visiting</h3>
      <div class="imgctn">
        <img src="./assets/iStock-931042070.jpg" alt="no image" class="constructimage"/>
      </div>
      <p class="newfont"></p>
      <button class="newfont" @click="deactivateModal">Continue To Site</button>
    </div>
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view 
          @Navigate="Redirect"
          @error="Error" 
          @success="Success" 
        />
      </keep-alive>
    </transition>
  </div>
</template>

<script>

//import Header from './components/Header.vue'
import ModalBackground from './components/ModalBackground.vue';
import { requester } from './utilities/Requester.js'
window.version = 6;
export default {
  name: 'App',
  components: {
    ModalBackground
  },
  data:function(){
    return {
      authenticated:false,
      showAuthentication:false,
      showform:'none',
      showReferral:true,
      showTermsAndCond:true,
      modalActive:true,
      modalStyles:{
        zIndex:1,
        opacity:"85%"
      },
      modalContentStyles:{
        position:"absolute",
        left:"50%",
        transform:"translateX(-50%)",
        zIndex:11
      }
    }
  },
  computed:{
    showSignup:function(){
      return this.showform === 'signup' && this.authenticated === false;
    },
    showSignin:function(){
      return this.showform === 'signin' && this.authenticated === false;
    },
    showSignout:function(){
      return this.showform === 'signout' && this.authenticated === true;
    }
  },
  methods:{
    Message(type="error",message="Error default",timeout=12000){
      let l = this.messages.length
      let y = 150*this.messages.length
      let m = {t:type,styles:{border:"",transform:`translateY(${y}px)`},msg:message,id:`notif${l}`,timeout:null}
      let sto = setTimeout(() => this.messages.pop(), timeout)
      m.timeout = sto;
      ////console.log(type);
      m.styles.border = "7px solid #d8d8d8"; 
      m.styles.borderRadius = "15px";
      if(type === "error"){
        m.styles.backgroundColor = "#ff6565";
        m.styles.color = "#760d0d";
      }
      if(type === "success"){
        m.styles.backgroundColor = "#74ff8b";
        m.styles.color = "#003c04";
      }
      if(type !== "success" && type !== "error"){
        m.styles.border = "7px solid #d8d8d8"; 
        m.styles.color = "#ffffff";
      }
      return m
    },
    Error(error){
      this.messages.push(this.Message('error',error))
    },
    Success(message){
      this.messages.push(this.Message('success',message,2100))
    },
    Redirect(path){
      this.$router.push({path:`/${path}`});
    },
    authFormView:function(e){
      this.activateModal()
      this.showform = e 
      if(e === "cancel"){
        this.deactivateModal()
      }
    },
    closeErrorBox:function(i){
      this.messages.splice(i,1)
      this.messages.map(x => x.styles.transform=`translateY(${i*150})`)
    },
    cancelForm:function(){
      this.deactivateModal()
      this.showform = "none"
    },
    activateModal(){
      document.querySelector('body').style.overflow = "hidden"
      this.modalActive = true;
      this.modalStyles = {
        zIndex:10,
        opacity:0.9
      }
    },
    deactivateModal(){
      document.querySelector('body').style.overflow = ""
      this.modalActive = false;
      this.showform = "none"
      this.modalStyles = {
        zIndex:-1,
        opacity:0
      }
    },
  },
  created:function(){
    document.eventCallbacks = {}
    document.appObserver = {
      register:(name,cb) => {
        if(!document.eventCallbacks[name]){
          document.eventCallbacks[name] = []; 
        }
        document.eventCallbacks[name].push(cb);
      },
      emit:(name) => {
        document.eventCallbacks[name].forEach(c => c())
      }
    }
    document.requestObserver = {
      register:(name,cb) => {
        if(!document.eventCallbacks[name]){
          document.eventCallbacks[name] = []; 
        }
        document.eventCallbacks[name].push(cb);
      },
      emit:(name) => (resp) => {
        if(document.eventCallbacks[name] && 
           Array.isArray(document.eventCallbacks[name])){
          document.eventCallbacks[name].forEach(c => c())
        }
        return resp
      }
    }
    ////console.log('created app.js');
    //document.stripeCard.mount("#cardElement")
    //document.authRequest = requester();
    document.messageRequest = requester('messages');
  },
  mounted:function(){
    document.addEventListener("keydown", (e) => {
      if(e.code === "Escape"){
        this.cancelForm()
      }        
    });
  }
}
</script>

<style>
html {
  scroll-behavior:smooth;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin:0;
  overflow-x:hidden;
}
.undermaintenence {
  position:fixed;
  width:100%;
  height:100%;
  z-index:4;
  color:black;
}
.constructimage {
  width:58%;
}
.imgctn {
  max-height: 600px;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  /* width: 100%; */
  background: white;
}
.flex {
  display:flex;
}
.center {
  justify-content:center;
}
.newfont {
  font-family:'Bodoni Elegant Regular';
  font-weight:100;
}

.fade-enter-active{
  transition: all 0.5s ease;
  opacity:0;
  transform: translateX(300px);  
}
.fade-enter-to{
  transition: all 0.5s ease;
  opacity:1;
  transform: translateX(0px);  
}

.fade-leave-to {
  transition: all .4s ease;
  animation: goLeft 0.7s 1 normal ease-out forwards;
  opacity:0;
}
@media only screen and (max-width: 600px) {

  .constructimage {
    width:111%;
  }
}

@keyframes goLeft {
0% {
  } 
100% {
  transform: translateX(-300px);  
  }
}
</style>
